import styled from 'styled-components';
import { TYPOGRAPHY } from '../../../theme/constants';

export const Input = styled.input.attrs({ type: 'text' })`
   ${TYPOGRAPHY.LIGHT};
   background: transparent;
`;
